import { render, staticRenderFns } from "./CollectionRecordAddAmount.vue?vue&type=template&id=100ad8ea&scoped=true"
import script from "./CollectionRecordAddAmount.vue?vue&type=script&lang=js"
export * from "./CollectionRecordAddAmount.vue?vue&type=script&lang=js"
import style0 from "./CollectionRecordAddAmount.vue?vue&type=style&index=0&id=100ad8ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100ad8ea",
  null
  
)

export default component.exports